// extracted by mini-css-extract-plugin
module.exports = {"metricsBox":"styles_metricsBox__3HVsE"};